module.exports = __webpack_public_path__ + "static/media/eye-evil.1b72a756.svg";